import React from 'react';
import { v4 as uuidv4 } from 'uuid';

const withAsyncId = Component => {
	class componentWithAsyncId extends React.Component {
		constructor(props, context) {
			super(props, context);
			this.asyncId = uuidv4();
		}
		render() {
			return <Component {...this.props} asyncId={this.asyncId} />;
		}
	}

	return componentWithAsyncId;
};

export default withAsyncId;
